import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestsRoutingModule } from './requests-routing.module';
import { RequestListComponent } from './requests-list/request-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { RequestListViewComponent } from './requests-list/request-list-view/request-list-view.component';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { RequestCardViewComponent } from './requests-list/request-card-view/request-card-view.component';
import { RequestListFilterComponent } from './requests-list/request-list-filter/request-list-filter.component';
import { RequestListPartnerFilterComponent } from './requests-list/request-list-partner-filter/request-list-partner-filter.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule } from '@angular/forms';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';

@NgModule({
  imports: [
    CommonModule,
    RequestsRoutingModule,
    TranslateModule.forChild(),
    ComponentsModule,
    DateInputsModule,
    FormsModule,
    PipeModule,
    DropDownsModule,
    InputsModule,
    NgbModule,
  ],
  declarations: [
    RequestListComponent,
    RequestListViewComponent,
    RequestCardViewComponent,
    RequestListFilterComponent,
    RequestListPartnerFilterComponent,
  ],
})
export class RequestsModule {}
